import styled from '@emotion/styled';
import Dialog from '@/components/Dialog';

const TagsDialog = styled(Dialog)({
  '.MuiDialog-paper': {
    width: '100%',
    maxWidth: 1000,
    maxHeight: 800,
    '.MuiDialogTitle-root': {
      display: 'flex',
      alignItems: 'center',
      '.MuiIconButton-root': {
        marginLeft: 'auto',
      },
    },
    '.MuiDialogContent-root': {
      flexShrink: 0,
    },
  },
});

export default TagsDialog;
